"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthProvider = exports.useAuth = exports.useAuthContext = exports.AuthContext = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@connect2ic/react");
const principal_1 = require("@dfinity/principal");
const react_3 = require("react");
const principalToAccountId_1 = require("@/utils/principalToAccountId");
const react_router_dom_1 = require("react-router-dom");
exports.AuthContext = (0, react_3.createContext)({
    loggedIn: false,
    isLoading: false,
});
const useAuthContext = () => (0, react_3.useContext)(exports.AuthContext);
exports.useAuthContext = useAuthContext;
const useAuth = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { activeProvider: activeWalletProvider, principal, disconnect: handleLogOut, isInitializing, isConnected, ...other } = (0, react_2.useConnect)({
        onConnect: () => {
        },
        onDisconnect: () => {
            navigate('/login');
        }
    });
    const [governanceActor] = (0, react_2.useCanister)('governance', { mode: 'connected' });
    const [ledgerActor] = (0, react_2.useCanister)('ledger', { mode: 'connected' });
    const [vestingActor] = (0, react_2.useCanister)('vesting', { mode: 'connected' });
    return {
        activeWalletProvider,
        governanceActor,
        ledgerActor,
        vestingActor,
        handleLogOut,
        other,
        isLoading: isInitializing,
        loggedIn: isConnected,
        principal: principal?.length > 0 ? principal_1.Principal.fromText(principal) : principal_1.Principal.anonymous(),
        accountID: (0, principalToAccountId_1.getAccountId)(principal?.length > 0 ? principal_1.Principal.fromText(principal) : principal_1.Principal.anonymous())
    };
};
exports.useAuth = useAuth;
const AuthProvider = ({ children }) => {
    const auth = (0, exports.useAuth)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.ConnectDialog, null),
        react_1.default.createElement(exports.AuthContext.Provider, { value: auth }, auth.isLoading ? (react_1.default.createElement(react_1.default.Fragment, null)) : (react_1.default.createElement(react_1.default.Fragment, null, children)))));
};
exports.AuthProvider = AuthProvider;
